// extracted by mini-css-extract-plugin
export default {"fullNameHeader":"ApplicantsSummaryTable_fullNameHeader__tKPf1","customerActions":"ApplicantsSummaryTable_customerActions__zSLoF"};